import { createUseStyles as createUseStyles$1 } from 'react-jss';

var createUseStyles = function createUseStyles(rules, options) {
  return createUseStyles$1(rules, options);
};

export { createUseStyles as default };
//# sourceMappingURL=index.js.map
